import React, { useCallback, useEffect, useRef, useState } from "react";
import { t, Trans } from "app/utils";
import ChqModalConfirm from "components/common/ChqModalConfirm";

interface StatusChangeConfirmModalProps {
  message?: React.ReactNode;
  onCancelSubmit: () => void;
  onSubmit: (values: any) => Promise<void>;
  showConfirmModal: boolean;
  values: any;
}

const StatusChangeConfirmModal: React.FC<StatusChangeConfirmModalProps> = ({
  message,
  onCancelSubmit,
  onSubmit,
  showConfirmModal,
  values
}) => {
  const triggerButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (showConfirmModal && triggerButtonRef.current) {
      setTimeout(() => {
        if (triggerButtonRef.current) {
          triggerButtonRef.current.click();
        }
      }, 50);
    }
  }, [showConfirmModal]);

  const handleConfirmSubmit = useCallback(async () => {
    await onSubmit(values);
  }, [onSubmit, values]);

  return (
    <ChqModalConfirm
      accept={t("Confirm")}
      onAccept={handleConfirmSubmit}
      onCancel={onCancelSubmit}
      trigger={(onTrigger: React.MouseEventHandler<HTMLButtonElement> | undefined) => (
        <button
          type="button"
          ref={triggerButtonRef}
          style={{ display: "none" }}
          onClick={onTrigger}
        >
          Trigger
        </button>
      )}
    >
      {message || (
        <Trans>
          In changing to Active status, any associated stories may now be
          selected for your Culture Page in the Admin Review tab
        </Trans>
      )}
    </ChqModalConfirm>
  );
};

export default StatusChangeConfirmModal;
